<template>
  <v-app id="inspire">
    <v-main
        style="height: 100%; width: 100%;"
    >
      <v-container
          fluid
          class="pa-0 ma-0"
          style="height: 100%; width: 100%;"
      >
        <v-row
            no-gutters
            style="height: 100%; width: 100%;"
        >
          <v-col
              class="ma-0 pa-0"
              style="height: 100%; width: 100%;"
          >
            <slot></slot>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  created() {
    this.$vuetify.theme.dark = false;
  }
}
</script>

<style scoped>

</style>
